var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 30,
    viewBox: "0 0 41 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.1267C1.31522 19.4044 2.63165 21.6817 3.94932 23.9584L34.771 16.5817L40.673 15L0 17.1267Z",
    fill: "#FE8700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.182 15.8508L11.969 25.2515L13.8351 28.4838C14.0955 28.9497 14.4769 29.3365 14.9391 29.6033C15.4012 29.8701 15.9269 30.0071 16.4605 29.9997H30.2585C30.7921 30.0071 31.3177 29.8701 31.7799 29.6032C32.242 29.3364 32.6234 28.9496 32.8837 28.4838L36.3399 22.4977L36.3436 22.4997L39.4912 17.0483L32.1538 21.1239L29.5299 25.6685H22.5075L32.8381 19.9303L40.182 15.8508Z",
    fill: "#032339"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2892 14.3163L40.345 14.4319L40.343 14.4283L35.0783 13.9509L12.7537 12.0207L17.1885 4.33118H29.5293L32.6041 9.65707V9.66553L34.6494 13.208L35.1351 13.2419L39.908 13.6746L36.343 7.49996L36.3393 7.50204L32.8832 1.51577C32.6228 1.05004 32.2413 0.66334 31.7792 0.396574C31.317 0.129807 30.7914 -0.00711207 30.2579 0.000285765H16.4597C15.9261 -0.00712751 15.4005 0.129819 14.9383 0.396634C14.4762 0.663449 14.0948 1.05022 13.8344 1.51602L10.3782 7.50229C9.06453 9.7738 8.06304 11.5038 6.75122 13.7762L35.2892 14.3163Z",
    fill: "#032339"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo-header.29f5dc838e7c2564e023ae2f4e7d45f2.svg";
export { ForwardRef as ReactComponent };